import React, { Component } from 'react';
import API from '@/api/api';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, DatePicker, Select, ConfigProvider, Input } from 'antd';
const { RangePicker } = DatePicker;
const { Option } = Select;

// /coupons/ticketStatistics

class TicketStatistics extends Component {

  constructor(props) {
    super(props);
  }

  state = {

    columns: [
      {
        title: '卡ID',
        dataIndex: 'carId',
      },
      {
        title: '卡名称',
        dataIndex: 'cardName',
      },
      {
        title: '用户ID',
        dataIndex: 'userId',
      },
      {
        title: '蚁盾分',
        dataIndex: 'yiDunScore',
      },
      {
        title: '用户手机号',
        dataIndex: 'userPhone',
      },
      {
        title: '用户名称',
        dataIndex: 'userName',
      },
      {
        title: '注册时间',
        dataIndex: 'registerTimeFormat',
      },
      {
        title: '领取时间',
        dataIndex: 'sendTimeFormat',
      },
      {
        title: '卡状态',
        dataIndex: 'status',
        render: (status) => (
          status == 5 ? '待激活' :
            status == 10 ? '已激活' :
              status == 20 ? '已用完' :
                status == 30 ? '过期' : ''
        )
      }
    ],

    searchCondition: {
      userId: undefined,
      userPhone: undefined,
      status: undefined,
      startTime: '',
      endTime: '',
      templateId: this.props.location.state.templateId,
      pageSize: 10,
      pageNo: 1,
    },

    pagination: {
      defaultPageSize: 10,
      hideOnSinglePage: true,
      showTotal: total => `总${total}条`,
      onChange: this.onPaginationChange.bind(this),
    },

    timeSelect: '',
  }

  componentDidMount() {
    this.getListData()
  }

  onPaginationChange(page) {
    let { searchCondition } = this.state;
    searchCondition.pageNo = page;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  onSearchDateChange = (date) => { //筛选条件 ：时间范围
    let { searchCondition } = this.state;
    let startTime = '', endTime = '';
    if (date.length == 0) {
      startTime = '';
      endTime = '';
    } else {
      startTime = Math.floor(date[0].valueOf() / 1000);
      endTime = Math.floor(date[1].valueOf() / 1000);
    }
    searchCondition.startTime = startTime;
    searchCondition.endTime = endTime;
    this.setState({ searchCondition });
  }

  onSelectChange(type, value) {//下拉框更改
    let { searchCondition } = this.state;
    searchCondition[type] = value
    this.setState({ searchCondition })
  }

  searchForData(type) {
    let { searchCondition } = this.state;
    if ('reset' === type) {
      searchCondition = {
        userId: undefined,
        userPhone: undefined,
        status: undefined,
        startTime: '',
        endTime: '',
        pageSize: 10,
        pageNo: 1,
      }
      this.setState({ timeSelect: new Date() });
    }
    this.setState({ searchCondition }, () => {
      this.getListData();
    })
  }

  lookInvitedUsers(userId) {
    this.props.history.push({ pathname: '/insuranceBroker/invitationList', state: { userId } })
  }

  async thdMatch(isMatch, recordId) {
    console.log('isMatch, recordId', isMatch, recordId)
    let result = await API.thdMatch({ isMatch, recordId })
    if (result.status == 1) {
      this.getListData();
    }
  }

  async getListData() {
    let { searchCondition, pagination } = this.state;
    let result = await API.cardUserList(searchCondition)
    if (result.status == 1) {
      let data = result.data;
      pagination.total = Number(data.totalNum);
      this.setState({
        datas: data.datas,
        pagination
      })
    }
  }

  InputItemChange(type, e) {
    let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
    let { searchCondition } = this.state;
    searchCondition[type] = value
    this.setState({ searchCondition })
  }

  render() {
    const {
      pagination,
      searchCondition,
      columns,
      datas,
      timeSelect
    } = this.state;
    return (
      <ConfigProvider locale={zhCN}>
        <div className="searchPane">
          <Input style={{ width: '150px' }} value={searchCondition.userId} onChange={this.InputItemChange.bind(this, 'userId')} placeholder="活动名称"></Input>
          <Input style={{ width: '150px', marginLeft: '20px' }} value={searchCondition.userPhone} onChange={this.InputItemChange.bind(this, 'userPhone')} placeholder="活动名称"></Input>
          <Select style={{ width: '200px', marginLeft: '20px' }} placeholder='请选择卡状态' value={searchCondition.status} onSelect={this.onSelectChange.bind(this, 'status')}>
            <Option value="5">待激活</Option>
            <Option value="10">已激活</Option>
            <Option value="20">已用完</Option>
            <Option value="30">过期</Option>
          </Select>
          <RangePicker
            className="rangePicker"
            format="YYYY-MM-DD"
            key={timeSelect}
            onChange={this.onSearchDateChange.bind(this)}
            style={{ marginLeft: '20px' }}
          ></RangePicker>
          <Button style={{ marginLeft: '20px' }} onClick={this.searchForData.bind(this, 'reset')}>重置</Button>
          <Button style={{ marginLeft: '20px' }} type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
        </div>
        <Table
          columns={columns}
          dataSource={datas}
          pagination={pagination}
          onChange={this.handleTableChange}
          rowKey='carId'
        />
      </ConfigProvider>
    )
  }
}

export default TicketStatistics;